import { render } from "./About2.vue?vue&type=template&id=4382f2ce&scoped=true"
import script from "./About2.vue?vue&type=script&lang=js"
export * from "./About2.vue?vue&type=script&lang=js"

import "./About2.vue?vue&type=style&index=0&id=4382f2ce&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4382f2ce"]])

export default __exports__